import { render, staticRenderFns } from "./addressSelect.vue?vue&type=template&id=cfe5f6a4&scoped=true&"
import script from "./addressSelect.vue?vue&type=script&lang=js&"
export * from "./addressSelect.vue?vue&type=script&lang=js&"
import style0 from "./addressSelect.vue?vue&type=style&index=0&id=cfe5f6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5f6a4",
  null
  
)

export default component.exports